<template>
  <div>
    <router-view> </router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

/**
 * TODO
 *  ・lazyload
 *    ・現状、imgの画像の指定をdata-srcからsrcに変更してしまっている
 */
export default defineComponent({
  name: "App",
  components: {},
});
</script>

<style scoped></style>
